import Image from "next/image";

export default function HomeCallToAction() {
    return (
        <>
            <div className="ptb-60 position-relative overflow-hidden z-1" >
                <span className="gradient-overlay position-absolute z-1"></span>
                <Image
                    src={'/img/dealers/bluecar.jpg'}
                    alt="not found"
                    fill
                    style={{
                        objectFit: 'cover',
                        objectPosition: 'right center',
                        zIndex: -1
                    }} />
                <div className="container">
                    <div className="box-call">
                        <div className="box-call-frame">
                            <h2 className="h1 text-white mb-3 text-border" style={{ textAlign: "center" }}>Os Melhores Negócios Começam Aqui</h2>
                            <p className="mb-3 text-white text-border" style={{ textAlign: "center", margin: "10px 30px" }}>
                                Nosso compromisso é proporcionar uma experiência diferenciada em cada negociação. Com atendimento consultivo, transparência e dedicação, ajudamos você a comprar, vender ou trocar seu veículo com confiança, segurança e as melhores condições do mercado.
                            </p>
                        </div>
                        <div className="box-call-frame-differ">
                            <a href="estoque/"><p className="button-call">Ver Estoque Completo</p></a>
                            <a href="contato/"><p className="button-call">Entre Em Contato</p></a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}